import { ArrowRight, ArrowUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Logo } from './Brand';
import { copy, SERVICES, displayTitle } from '../data/website';

export const Footer = ({ onPlan, onDiscover }) => (
  <footer className="site-footer" data-testid="footer">
    <div className="site-container">
      <div className="footer-grid">
        {/* Brand Col */}
        <div className="footer-brand">
          <Link to="/" aria-label="Giraffe Entertainment & Experiences Home">
            <Logo id="footer-brand-logo" />
          </Link>
          <p className="gee-footer-tagline" data-testid="footer-brand-tagline">
            {copy.footer.tagline}
          </p>
          <p className="footer-corp-address">
            Giraffe Corporate House, House No 292, Asiad Village, Near Sirifort Auditorium, New Delhi – 110049
          </p>
        </div>

        {/* Company Navigation */}
        <nav aria-label="Company">
          <h3>Explore</h3>
          <Link to="/" data-testid="footer-link-home">Home</Link>
          <Link to="/about-us" data-testid="footer-link-about">About Us</Link>
          <a href="/#experiences" data-testid="footer-link-experiences">Experiences</a>
          <a href="https://guptarghat.com" target="_blank" rel="noopener noreferrer" data-testid="footer-link-flagship">Flagship 7D Cinema</a>
          <Link to="/contact-us" data-testid="footer-link-contact">Contact Us</Link>
        </nav>

        {/* Legal & Policies */}
        <nav aria-label="Legal and Policies">
          <h3>Policies</h3>
          <Link to="/terms-and-conditions" data-testid="footer-link-terms">Terms &amp; Conditions</Link>
          <Link to="/privacy-policy" data-testid="footer-link-privacy">Privacy Policy</Link>
          <Link to="/refund-and-cancellation" data-testid="footer-link-refund">Refund &amp; Cancellation</Link>
          <button className="footer-nav-btn" onClick={() => onPlan('General enquiry')}>Guest Support</button>
        </nav>

        {/* Connect & Partner */}
        <div className="footer-connect">
          <h3>Partner with GEE</h3>
          <p>{copy.partner.intro}</p>
          <button className="text-link" onClick={() => onPlan('Partnership')} data-testid="footer-partner">
            {copy.partner.cta}<ArrowRight size={16} />
          </button>
          <Link to="/contact-us" className="text-link" data-testid="footer-contact">
            Get in Touch<ArrowRight size={16} />
          </Link>
        </div>
      </div>

      <div className="footer-bottom">
        <span data-testid="footer-copyright">
          © {new Date().getFullYear()} Giraffe Entertainment &amp; Experiences (Giraffe Group). All rights reserved.
        </span>
        <div className="footer-bottom-legal">
          <Link to="/terms-and-conditions">Terms</Link>
          <span className="dot-sep">•</span>
          <Link to="/privacy-policy">Privacy</Link>
          <span className="dot-sep">•</span>
          <Link to="/refund-and-cancellation">Refund Policy</Link>
          <span className="dot-sep">•</span>
          <Link to="/contact-us">Contact</Link>
        </div>
        <a href="#top" className="back-to-top" data-testid="footer-back-to-top">
          Back to top<ArrowUp size={14} />
        </a>
      </div>
    </div>
  </footer>
);